export const normalizeRfidCode = (
  value?: string | null,
): string | undefined => {
  const normalized = (value || '').replace(/\s/g, '').toUpperCase();
  return normalized.length > 0 ? normalized : undefined;
};

export const rfidCodeCandidates = (
  value?: string | null,
): string[] => {
  const trimmed = value?.trim();
  const normalized = normalizeRfidCode(value);
  return Array.from(
    new Set(
      [trimmed, normalized, trimmed?.toLowerCase()]
        .filter((candidate): candidate is string => !!candidate),
    ),
  );
};

const isRecordValue = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const normalizeOicpIdentificationRfids = <T>(
  identification: T,
): T => {
  if (!isRecordValue(identification)) {
    return identification;
  }

  const normalized: Record<string, unknown> = { ...identification };

  for (const key of ['RFIDMifareFamilyIdentification', 'RFIDIdentification']) {
    const value = normalized[key];
    if (!isRecordValue(value)) {
      continue;
    }

    normalized[key] = {
      ...value,
      UID: normalizeRfidCode(
        typeof value.UID === 'string' ? value.UID : undefined,
      ) ?? value.UID,
    };
  }

  return normalized as T;
};
